import ButtonCommon from 'components/common/ButtonCommon';
import SizeBox from 'components/common/SizeBox';
import { DESKTOP_MIN_WIDTH, TABLET_MAX_WIDTH } from 'constants';
import {
  PAYTO_ERROR_CODE_MAPPING,
  PAYTO_ERROR_CODE_MAPPING_TITLE,
} from 'features/to/const';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useLang from 'hooks/useLang';
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import styled from 'styled-components';
import { paragraph500Mixin, paragraph700Mixin } from 'styles';

const AuthorisePaytoAccountRejectedPopup = ({
  isOpen,
  imageSrc,
  imagesStyles,
  alignContent = 'left' || 'center' || 'right',
  onClose,
  onClick,
  isBackdropOverlap,
  zIndexBackdropOverlap,
  zIndexModal = 0,
  isClickBackdropToClose = false,
  errorData,
  modalOptions,
}) => {
  const { t } = useLang();
  // text={t('form_add_payto_account_rejected_title')}
  // content={t('form_add_payto_account_timeout_desc_')} || t(PAYTO_ERROR_CODE_MAPPING[errorCode])

  // buttonLabel1={t('button_dismiss')}
  // buttonLabel2={t('button_try_again')}
  // buttonLabel2={t('button_close')} when has errorCode

  const { isAccountAgreementEditing } = usePaytoStore();

  const { errorCode } = errorData || {};

  const { isEdit } = modalOptions || {};

  useEffect(() => {
    console.log(`⭐ AuthorisePaytoAccountRejectedPopup 👉 isEdit ↩`, isEdit);
  }, []);

  const getModalTitle = () => {
    if (!isEmpty(errorCode))
      return t(PAYTO_ERROR_CODE_MAPPING_TITLE[errorCode?.toUpperCase()]);
    return isEdit
      ? t('form_update_payto_account_rejected_title')
      : t('form_add_payto_account_rejected_title');
  };

  const getModalBodyContent = () => {
    if (!isEmpty(errorCode))
      return t(PAYTO_ERROR_CODE_MAPPING[errorCode?.toUpperCase()]);
    return isEdit
      ? t('form_update_payto_account_rejected_desc')
      : t('form_add_payto_account_rejected_desc');
  };

  const renderActionButtons = () => {
    if (!isEmpty(errorCode))
      return (
        <ButtonCommon
          value={t('button_close')}
          color="var(--c-primary)"
          background="var(--bg-primary)"
          isFill={true}
          styles={{
            margin: '0px',
            width: '100%',
          }}
          onClick={onClick}
          isUseKeyDown
        />
      );
    if (isEdit)
      return (
        <ButtonCommon
          value={t('button_try_again')}
          color="var(--c-primary)"
          background="var(--bg-primary)"
          isFill={true}
          styles={{
            margin: '0px',
            width: '100%',
          }}
          onClick={onClick}
          isUseKeyDown
        />
      );
    if (isAccountAgreementEditing)
      return (
        <ButtonCommon
          value={t('button_close')}
          color="var(--c-primary)"
          background="var(--bg-primary)"
          isFill={true}
          styles={{
            margin: '0px',
            width: '100%',
          }}
          onClick={onClick}
          isUseKeyDown
        />
      );
    return (
      <>
        <ButtonCommon
          value={t('button_try_again')}
          color="var(--c-primary)"
          background="var(--bg-primary)"
          isFill={true}
          styles={{
            margin: '0px',
            width: '100%',
          }}
          onClick={onClick}
          isUseKeyDown
        />
      </>
    );
  };

  return (
    <>
      <style>
        {zIndexModal
          ? `
          @media screen and (max-width: ${TABLET_MAX_WIDTH - 1}px) {
            .modal {
              z-index: ${zIndexModal || 1101};
            }
          }
        `
          : ``}

        {isBackdropOverlap
          ? `
          .alert-modal-backdrop {
            z-index: ${zIndexBackdropOverlap || 1100}!important;
            background: #212121;
            opacity: 0.7!important;
            display: initial!important;
          }
        `
          : `
        .alert-modal-backdrop {
          background: #212121;
          opacity: 0.7!important;
          display: initial!important;
        }
      `}
      </style>
      <ModalStyled
        show={isOpen}
        onHide={() => {}}
        aria-labelledby="contained-modal-title-vcenter"
        backdropClassName="alert-modal-backdrop"
        centered
      >
        <ModalBody>
          {imageSrc && (
            <>
              <ImageWrap>
                <img
                  src={imageSrc}
                  alt=""
                  width={50}
                  height={50}
                  style={imagesStyles}
                />
              </ImageWrap>
              <SizeBox height={10} />
            </>
          )}
          <Text
            dangerouslySetInnerHTML={{
              __html: getModalTitle(),
            }}
          />
          <SubText
            $alignContent={alignContent}
            dangerouslySetInnerHTML={{ __html: getModalBodyContent() }}
          />
        </ModalBody>
        <ModalFooter>{renderActionButtons()}</ModalFooter>
      </ModalStyled>
    </>
  );
};

const ModalStyled = styled(Modal)`
  & .modal-dialog {
    transform: none;
    & .modal-content {
      padding: 14px;
      border-radius: 8px;
      box-shadow: var(--ds-bs-4);
      background: var(--ds-c-white);
      width: 328px;
      height: fit-content;
      margin-inline: auto;
      border: none;

      @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
        width: 436px;
      }
    }
  }
`;
const ModalBody = styled(Modal.Body)`
  padding: 0;
  margin-bottom: 24px;
  text-align: left;
`;
const ImageWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const Text = styled.p`
  ${paragraph700Mixin};
  text-align: center;
  margin-bottom: 4px;
`;
const SubText = styled.p`
  ${paragraph500Mixin};
  text-align: ${(props) => props.$alignContent};
  white-space: break-spaces;

  & a {
    text-decoration: none;
    color: var(--ds-c-blue-hyperlink-default);
  }

  & b {
    color: var(--ds-c-blue-hyperlink-default);
  }
`;

const ModalFooter = styled(Modal.Footer)`
  border: none;
  padding: 0;
  display: flex;
`;

export default AuthorisePaytoAccountRejectedPopup;
